export default {
	create (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_shop_skill_attribute/create', params)
	},
	delete (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_shop_skill_attribute/delete', params)
	},
	all (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_shop_skill_attribute/all', params)
	},
	one (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'staff_shop_skill_attribute/one', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/StaffShopSkillAttribute.js